module.exports = __webpack_public_path__ + "static/sixsik-sa-papremyo-main-promo-page-ec7a91242796ce3ca03b67ff6af0719c.jpg";